module.exports = __webpack_public_path__ + "static/media/nexone-logo.2a857b68.png";